import * as React from "react";
const SvgGrid24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 20,
        fill: "black",
        viewBox: "0 0 22 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 0h22v20H0V0Zm2 2v7h8V2H2Zm10 0v7h8V2h-8Zm8 9h-8v7h8v-7Zm-10 7v-7H2v7h8Z",
      clipRule: "evenodd"
    })
  );
export default SvgGrid24Px;
